//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { expensesInfo } from '@/model/api/insuranceService'
import { promptly } from '@/utils/commonServes.js'

export default {
    name:'records',
    data(){
        return {
            expenses:{},
            expect:'',
            allAmout:0,
            stage_list:[],
            uuid:'',
            templateFlag:'',
            stateFlag:'',
            entrust_detail:{}
        }
    },
    created() {
        this.uuid = this.$route.query.uuidBx;
        this.stateFlag = this.$route.query.stateFlag
        this.templateFlag = this.$route.query.templateFlag;
        this.getExpensesInfo()
       

    },
    mounted(){
    },
    methods:{
        toastFnOrder(){
            this.$toast("开通成功");
            this.getExpensesInfo()
        },
        getExpensesInfo(){
            expensesInfo( this.uuid ).then(data=>{
                for( let val of data.stage_list){
                    val.amount = val.amount/100
                }
                this.allAmout = data.total_amount/100
                this.stage_list = data.stage_list
                this.expect = `${data.payed_times}/${data.period}`
                this.entrust_detail = data.entrust_detail
                let idx = data.stage_list.length -1
                let first_amount =  data.stage_list
                data.first_amount = data.stage_list[idx].amount
                data.amount = data.amount/100
                data.payable_amount = data.payable_amount/100
                this.expenses = data
                
            })
        },
        dredge(stateFlag){
          if(stateFlag == 38){
            this.STATISTICS('click','sybao_ins_payments_pay_click')

          }else{
            this.STATISTICS('click','sybao_ins_payments_sign_click')

          }
            promptly(this.uuid,this,this.templateFlag,'order')
            // .then(data=>{
            //     console.log(data)
                
            // });
        },
    }
}
